export default "__VITE_ASSET__3Qr6TFqM__"